<template>
  <modal name="salvage-bid-modal"
     :width="600"
     :height="480" 
  >
    <div>
      <div style="text-align:center;padding-top:20px">
        <h2>Salvage Bid</h2>
      </div>
      <div>
        <v-stepper
          v-model="e1"   
        >
          <v-stepper-header>
            <v-stepper-step :complete="e1 > 1" step="1">Client Details</v-stepper-step>
            <v-divider></v-divider>          
            <v-stepper-step :complete="e1 > 2" step="2">Vehicle Details</v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card>
                <v-card-text style="padding-bottom:0">
                  <v-form ref="form">
                    <v-row class="ma-0 pa-0"
                    >
                      <v-col
                        class="ma-0 pa-0"
                        cols="12"
                        sm="6"
                      >                   
                        <v-text-field v-if="user.loggedIn"
                          label="First name"                        
                          v-model="user.first_name"                    
                          outlined
                          dense            
                          style="padding-right:5px"
                        >  
                        </v-text-field>
                        <v-text-field v-else
                          label="First name"                        
                          v-model="salvageBid.first_name"                    
                          outlined
                          dense            
                          style="padding-right:5px"
                        >  
                        </v-text-field>
                      </v-col>
                      <v-col 
                        class="ma-0 pa-0"
                        cols="12"
                        sm="6"
                      > 
                        <v-text-field v-if="user.loggedIn"
                          label="Last name"
                          v-model="user.last_name"                      
                          outlined
                          dense                       
                          style="padding-left:5px"
                        >  
                        </v-text-field>
                        <v-text-field v-else
                          label="Last name"
                          v-model="salvageBid.last_name"                      
                          outlined
                          dense                       
                          style="padding-left:5px"
                        >  
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row
                      class="ma-0 pa-0"
                    >
                      <v-col
                        class="ma-0 pa-0"
                        cols="12"
                        sm="6"
                      >    
                        <v-text-field v-if="user.loggedIn"
                          label="Email address"
                          v-model="user.data.email"                  
                          outlined
                          dense            
                          style="padding-right:5px" 
                        >  
                        </v-text-field>
                        <v-text-field v-else
                          label="Email address"
                          v-model="salvageBid.email_address"                  
                          outlined
                          dense            
                          style="padding-right:5px" 
                        >  
                        </v-text-field>
                      </v-col>
                      <v-col
                        class="ma-0 pa-0"
                        cols="12"
                        sm="6"
                      >   
                        <v-text-field
                          label="Mobile No"
                          v-model="salvageBid.mobile_no"
                          outlined
                          dense            
                          style="padding-left:5px"                        
                        >  
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row
                      class="ma-0 pa-0"
                    >
                      <v-col
                        class="ma-0 pa-0"
                        cols="12"
                        sm="6"
                      >       
                        <v-select              
                          :items="province_list"
                          label="Province"
                          v-model="salvageBid.province"
                          item-text="text"
                          item-value="value"
                          dense
                          outlined    
                          return-object  
                          style="padding-right:5px"                             
                        >
                        </v-select>
                      </v-col>
                      <v-col 
                        class="ma-0 pa-0"
                        cols="12"
                        sm="6"
                      > 
                        <v-select             
                          :items="city_list"
                          v-model="salvageBid.city"
                          label="City"
                          item-text="text"
                          item-value="value"
                          dense
                          return-object
                          outlined     
                          style="padding-left:5px"          
                        >
                        </v-select>
                      </v-col>    
                    </v-row>      
                    <v-text-field
                      label="Physical Address"
                      v-model="salvageBid.physical_address"
                      outlined
                      dense                                   
                    >  
                    </v-text-field>
                  </v-form>
                </v-card-text>              
              </v-card> 
              <v-btn
                color="primary"
                @click="e1 = 2"
              >
                Continue
              </v-btn>
              <v-btn 
                text
                @click="$modal.hide('salvage-bid-modal')"
              >
                Cancel
              </v-btn>
            </v-stepper-content>
            <v-stepper-content step="2">
              <v-card>
                <v-card-text style="padding-bottom:0">
                  <v-form class="ma-0 pa-0" ref="form"> 
                    <v-row class="ma-0 pa-0"
                    >
                      <v-col
                        class="ma-0 pa-0"
                        cols="12"
                        sm="6"
                      >                 
                        <v-text-field
                          label="Vehicle reg"
                          v-model="salvageBid.vehicle_reg"                      
                          outlined
                          dense            
                          style="padding-right:5px" 
                        >  
                        </v-text-field>
                      </v-col>
                      <v-col
                        class="ma-0 pa-0"
                        cols="12"
                        sm="6"
                      >  
                        <v-text-field
                          label="Year of manf."
                          v-model="salvageBid.year_of_manf"                      
                          outlined
                          dense            
                          style="padding-left:5px" 
                        >  
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row
                      class="ma-0 pa-0"
                    >
                      <v-col
                        class="ma-0 pa-0"
                        cols="12"
                        sm="6"
                      >       
                        <v-text-field
                          label="Client NRC"
                          v-model="salvageBid.nrc_number"
                          outlined
                          dense                
                          :rules="input_rules"
                          style="padding-right:5px"              
                        >  
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        class="ma-0 pa-0"
                      >             
                        <v-text-field
                          label="Client T-PIN"  
                          v-model="salvageBid.tpin_number"              
                          outlined
                          dense
                          :rules="input_rules"
                          style="padding-left:5px"             
                        > 
                        </v-text-field>
                      </v-col>       
                    </v-row>
                    <v-row
                      class="ma-0 pa-0"
                    >
                      <v-col
                        cols="12"
                        sm="6"
                        class="ma-0 pa-0"
                      >       
                        <v-text-field
                          label="Vehicle Make"
                          v-model="salvageBid.vehicle_make"
                          :rules="input_rules"
                          dense
                          outlined               
                          style="padding-right:5px" 
                        >  
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        class="ma-0 pa-0"
                      >             
                        <v-text-field
                          label="Vehicle Model"
                          v-model="salvageBid.vehicle_model"
                          :rules="input_rules"
                          dense
                          outlined
                          style="padding-left:5px" 
                        > 
                        </v-text-field>
                      </v-col>       
                    </v-row>    
                    <v-row
                      class="ma-0 pa-0"
                    >
                      <v-col
                        cols="12"
                        sm="6"
                        class="ma-0 pa-0"
                      >           
                        <v-text-field
                          label="Location"
                          v-model="salvageBid.location"
                          :rules="input_rules"
                          dense
                          outlined           
                          style="padding-right:5px" 
                        >        
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        class="ma-0 pa-0"
                      >           
                        <v-text-field
                          label="Bid Amount"
                          v-model="salvageBid.bid_amount"
                          :rules="input_rules"
                          dense
                          outlined           
                          style="padding-left:5px" 
                        >        
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
              <v-btn
                color="primary"
                @click="saveBid"
              >
                Submit Bid
              </v-btn>
              <v-btn 
                text
                @click="e1 = 1"
              >
                Previous
              </v-btn>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </div>
    </div>
  </modal>
</template>
<script>
  import { mapGetters } from "vuex";

  export default {
    name: 'SalvagesBidModal',
    data: () => ({
      e1: 1,
      steps: 2,
      input_rules: [
       // v => v.length > 0 || 'This field is required'
      ],
      loading: false,
      province_list: [
        { text: 'Lusaka', value: 'lsk' },
        { text: 'Copperbelt', value: 'cbt' }
      ],
      city_list: [
        { text: 'Lusaka', value: 'lsk' },
        { text: 'Ndola' , value: 'ndl' },
        { text: 'Kitwe', value: 'ktk' },
        { text: 'Chingola', value: 'cng' },
        { text: 'Luanshya', value: 'lya' },
        { text: 'Kalulushi', value: 'kls' },
        { text: 'Mufurila', value: 'muf' },
      ],
    }),
    methods: {
      saveBid() {
        //save bid
      }
    },
    computed: {
      ...mapGetters({
        user: "user",
        salvageBid: "salvageBid"
      }),
    }
  }
</script>